(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[198,33502,92591,79875],{

/***/ 8712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ capitalizeFirstLetter; }
/* harmony export */ });
const capitalizeFirstLetter = (str)=>{
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};


/***/ }),

/***/ 198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bw": function() { return /* binding */ canShowFieldAfterDependency; },
  "wY": function() { return /* binding */ fieldValidation; },
  "zJ": function() { return /* binding */ fullNameValidation; },
  "dR": function() { return /* binding */ getFirstIncompleteStep; },
  "V2": function() { return /* binding */ getServerSideValidationErrorMessage; },
  "aC": function() { return /* binding */ gettingDateFromDays; },
  "yr": function() { return /* binding */ handleFieldMasking; }
});

// UNUSED EXPORTS: dateDiff

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(29204);
;// CONCATENATED MODULE: ./src/i18n/shared/errorMessages/getErrorMessages.tsx

const getErrorMessage = ({ fieldName , errorType , field , messages  })=>{
    const getDate = ()=>{
        if (field?.maxValue?.type === "date") return new Date(field[errorType === "MAX_DATE_ERROR" ? "maxValue" : "minValue"]?.value).toLocaleDateString("en-US");
        return new Date(gettingDateFromDays(parseInt(field[errorType === "MAX_DATE_ERROR" ? "maxValue" : "minValue"]?.value, 10))).toLocaleDateString("en-US");
    };
    const errorMessage = messages[errorType];
    return errorMessage?.replace("${field}", fieldName?.toLowerCase())?.replace("${date}", errorType === "MAX_DATE_ERROR" || errorType === "MIN_DATE_ERROR" ? getDate() : "") ?? fieldName;
};

// EXTERNAL MODULE: ./src/api/index.ts + 19 modules
var api = __webpack_require__(21513);
// EXTERNAL MODULE: ./src/lib/capitalizeFirstLetter.ts
var capitalizeFirstLetter = __webpack_require__(8712);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
;// CONCATENATED MODULE: ./src/lib/shared/form.ts





// datePart: 'y', 'm', 'w', 'd', 'h', 'n', 's'
const dateDiff = (datePart, fromDate, toDate)=>{
    const diff = toDate - fromDate;
    const divideBy = {
        w: 604800000,
        d: 86400000,
        h: 3600000,
        n: 60000,
        s: 1000
    };
    return Math.floor(diff / divideBy[datePart.toLowerCase()]);
};
const getServerSideValidationErrorMessage = (error, fieldName, domain, locale)=>{
    error.response?.data?.validationMessage;
    const fallBackMessage = error?.response?.data?.validationMessage ?? error?.response?.data?.message ?? `${fieldName} is invalid`;
    return (0,sharedUtils/* getErrorMessageTranslation */.Ul)(domain, error?.response?.data?.errorCode ?? "", locale, fallBackMessage);
};
const canShowFieldAfterDependency = (field, fieldsState)=>{
    if (field.conditionalLogic && field.conditionalLogic.isActive) {
        let finalState = field.conditionalLogic.operator === "AND" ? true : false;
        const conditionOperators = {
            equal: (value1, value2)=>value1 === value2,
            notEqual: (value1, value2)=>value1 !== value2
        };
        field.conditionalLogic.conditions.forEach((condition)=>{
            const state = conditionOperators[condition.operator](fieldsState[condition.codeName]?.value, condition.value);
            finalState = field.conditionalLogic.operator === "AND" ? finalState && state : finalState || state;
        });
        return field.conditionalLogic.action === "show" ? finalState : !finalState;
    }
    return true;
};
function getFirstIncompleteStep(steps, fieldsState) {
    for(let i = 0; i < steps.length; i++){
        const requiredFields = steps[i].fields.filter((field)=>field.isRequired === true && canShowFieldAfterDependency(field, fieldsState));
        const allRequiredFieldsFilled = requiredFields.every((field)=>fieldsState[field.codeName]?.value && fieldsState[field.codeName]?.valid === true);
        if (!allRequiredFieldsFilled) {
            return i;
        }
    }
    return steps.length - 1;
}
const gettingDateFromDays = (days)=>{
    const date = new Date();
    const last = new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
    return last.toISOString().split("T")[0];
};
const resolveRegulation = (meta, data)=>{
    if (meta?.stateRegulation) {
        return meta.stateRegulation === data?.stateCode;
    }
    return false;
};
const fullNameValidation = async ({ firstName , lastName , domain , locale  })=>{
    const { data , error  } = await (0,api/* validateField */.OP)({
        ruleName: "fullName",
        value: {
            firstName,
            lastName
        }
    });
    if (error && error?.response && (error?.response?.status === 502 || error?.response?.status === 503 || error?.response?.status === 504)) {
        return {
            valid: true,
            message: "",
            newValue: undefined,
            validationSkipped: true
        };
    }
    if (error || !data) {
        return {
            valid: false,
            message: getServerSideValidationErrorMessage(error, "Full Name", domain, locale),
            newValue: undefined
        };
    }
    return {
        valid: true,
        message: "",
        newValue: data.replaceValue && typeof data.value === "string" ? data.value : undefined
    };
};
const buildRulesVariablesMapping = (context)=>{
    const storedReferrer =  true ? sessionStorage.getItem("page_referrer") : 0;
    return {
        phoneNumber: context?.phoneNumber ?? null,
        referral: context?.referrer ?? storedReferrer ?? null,
        visit: context?.visitDetails ?? null,
        visitor: context?.userAgent ?? null
    };
};
const checkSectionRules = (rules, rulesVariablesMapping)=>{
    // No rules means check the validation should be applied, return true to not block it
    if (!rules.length) return true;
    const isEmpty = (value)=>value === undefined || value === null || value === "";
    const parseCommaSeparated = (value)=>value.split(",").map((v)=>v.trim());
    const evaluateRule = (ruleOption)=>{
        let ruleValue = rulesVariablesMapping[ruleOption.rule];
        // Extract nested property if codeName is specified
        if (ruleOption.codeName && ruleValue && typeof ruleValue === "object") {
            ruleValue = ruleValue[ruleOption.codeName];
        }
        const { operator , value  } = ruleOption;
        switch(operator){
            case "equal":
                return ruleValue === value;
            case "notEqual":
                return ruleValue !== value;
            case "notExist":
                return isEmpty(ruleValue);
            case "exist":
                return !isEmpty(ruleValue);
            case "includes":
                if (typeof ruleValue === "string") return ruleValue.includes(value);
                if (Array.isArray(ruleValue)) return ruleValue.includes(value);
                return false;
            case "notIncludes":
                if (typeof ruleValue === "string") return !ruleValue.includes(value);
                if (Array.isArray(ruleValue)) return !ruleValue.includes(value);
                return true; // If not string/array, treat as "not included"
            case "containsOne":
                if (typeof ruleValue !== "string") return false;
                return parseCommaSeparated(value).some((item)=>ruleValue.includes(item));
            case "containsAll":
                if (typeof ruleValue !== "string") return false;
                return parseCommaSeparated(value).every((item)=>ruleValue.includes(item));
            case "notOneOf":
                if (typeof ruleValue !== "string") return true;
                return parseCommaSeparated(value).every((item)=>!ruleValue.includes(item));
            default:
                return false;
        }
    };
    // OR between groups, AND within each group
    const rulesMatch = rules.some((group)=>group.every(evaluateRule));
    return rulesMatch;
};
const rejectedAnswersValidation = (field, value, rejectedAnswersRules, rulesContext)=>{
    if (field.meta?.rejectedAnswers) {
        const rejectedAnswers = field.meta?.rejectedAnswers.split(",").map((s)=>s.trim());
        if (rejectedAnswers.includes(value)) {
            const rulesVariablesMapping = buildRulesVariablesMapping({
                ...rulesContext
            });
            if (rejectedAnswersRules && rejectedAnswersRules?.length) {
                const shouldApplyRejectedAnswerValidation = checkSectionRules(rejectedAnswersRules, rulesVariablesMapping);
                if (!shouldApplyRejectedAnswerValidation) {
                    return null;
                }
            }
            let message = "Please choose another value";
            let rejectedMessage = {};
            try {
                const parsed = JSON.parse(field.meta?.rejectedMessage || "{}");
                if (parsed && typeof parsed === "object") {
                    const candidate = parsed;
                    rejectedMessage = {
                        defaultMessage: typeof candidate.defaultMessage === "string" ? candidate.defaultMessage : undefined,
                        phoneMessage: typeof candidate.phoneMessage === "string" ? candidate.phoneMessage : undefined
                    };
                }
            } catch  {
            // ignore invalid rejectedMessage JSON
            }
            message = rejectedMessage.defaultMessage || message;
            if (rulesVariablesMapping?.phoneNumber && rejectedMessage.phoneMessage) {
                message = (0,sharedUtils/* replacePlaceholders */.wT)(rejectedMessage.phoneMessage, {
                    phoneNumber: rulesVariablesMapping.phoneNumber
                });
            }
            return {
                message,
                isValid: false,
                hasRegulations: false,
                validationSkipped: false
            };
        }
    }
    return null;
};
const patternValidation = (field, value)=>{
    if (field.pattern) {
        const reg = new RegExp(field.pattern);
        const isValid = reg.test(String(value).toLowerCase());
        if (!isValid) {
            return {
                errorType: "INVALID_ERROR",
                isValid: false,
                hasRegulations: false,
                validationSkipped: false
            };
        }
    }
    if ((field.maxValue?.value || field.maxValue?.value === "0") && field.fieldType !== "select" && field.fieldType !== "radio" && field.fieldType !== "range" && field.fieldType !== "checkbox" && field.fieldType !== "calculatedYears") {
        if (field.fieldType === "date" && field.maxValue?.type === "date") {
            const isValid1 = dateDiff("d", new Date(value), new Date(field.maxValue?.value)) >= 0;
            if (!isValid1) {
                return {
                    errorType: "INVALID_ERROR",
                    isValid: false,
                    hasRegulations: false,
                    validationSkipped: false
                };
            }
        } else if (field.fieldType === "date") {
            const isValid2 = dateDiff("d", new Date(value), new Date(gettingDateFromDays(field.maxValue?.value))) >= 0;
            if (!isValid2) {
                return {
                    errorType: "MAX_DATE_ERROR",
                    isValid: false,
                    hasRegulations: false,
                    validationSkipped: false
                };
            }
        } else {
            const isValid3 = value.trim().length <= field.maxValue.value;
            if (!isValid3) {
                return {
                    errorType: "INVALID_ERROR",
                    isValid: false,
                    hasRegulations: false,
                    validationSkipped: false
                };
            }
        }
    }
    // return null
    if ((field.minValue?.value || field.minValue?.value === "0") && field.fieldType !== "select" && field.fieldType !== "radio" && field.fieldType !== "range" && field.fieldType !== "checkbox" && field.fieldType !== "calculatedYears") {
        if (field.fieldType === "date" && field.minValue?.type === "date") {
            const isValid4 = dateDiff("d", new Date(value), new Date(field.minValue?.value)) <= 0;
            if (!isValid4) {
                return {
                    errorType: "MIN_DATE_ERROR",
                    isValid: false,
                    hasRegulations: false,
                    validationSkipped: false
                };
            }
        } else if (field.fieldType === "date") {
            const isValid5 = dateDiff("d", new Date(gettingDateFromDays(field.minValue?.value)), new Date(value)) >= 0;
            if (!isValid5) {
                return {
                    errorType: "MIN_DATE_ERROR",
                    isValid: false,
                    hasRegulations: false,
                    validationSkipped: false
                };
            }
        } else {
            const isValid6 = value.trim().length >= field.minValue.value;
            if (!isValid6) {
                return {
                    errorType: "INVALID_ERROR",
                    isValid: false,
                    hasRegulations: false,
                    validationSkipped: false
                };
            }
        }
    }
    return null;
};
const serverSideValidation = async (field, value, selectedCountryCode, handleUpdateOffers, fieldName, domain, locale)=>{
    const { data , error  } = await (0,api/* validateField */.OP)({
        ruleName: field.validationType,
        value,
        countryCode: selectedCountryCode
    });
    if (field.codeName === "zipCode" && data?.value && typeof data?.value !== "string" && "stateCode" in data.value && handleUpdateOffers) {
        handleUpdateOffers(data.value.stateCode);
    }
    // if validation server is down (status === 503 || status === 504)
    // we need to skip the validation for the step and continue to the next step without any interruptions
    // we also save the fields that haven't been validated and send them in meta object on submit
    if (error) {
        if (error instanceof axios/* AxiosError */.d7 && (error?.response?.status === 502 || error?.response?.status === 503 || error?.response?.status === 504)) return {
            isValid: true,
            message: "",
            hasRegulations: false,
            validationSkipped: true
        };
        return {
            isValid: false,
            message: getServerSideValidationErrorMessage(error, fieldName, domain, locale),
            newValue: undefined,
            hasRegulations: false,
            validationSkipped: false
        };
    }
    if (data) {
        const hasRegulations = field.meta ? resolveRegulation(field.meta, data.value) : false;
        return {
            isValid: true,
            message: "",
            newValue: data.replaceValue && typeof data.value === "string" ? data.value : undefined,
            hasRegulations,
            validationSkipped: false
        };
    }
    return null;
};
const fieldValidation = async (field, value, locale, selectedCountryCode, handleUpdateOffers, domain, domainEnableRejectedAnswer, rejectedAnswersRules, rulesContext)=>{
    const messages = __webpack_require__(99732)(`./${locale}.json`);
    const fieldName = field.niceName ? field.niceName : field.title ? field.title : "field";
    if (!value) {
        if (field.isRequired || field.conditionalLogic?.isActive && field.conditionalLogic.requiredWhenShown) {
            const message = (0,capitalizeFirstLetter/* capitalizeFirstLetter */.f)(getErrorMessage({
                messages,
                fieldName,
                errorType: "REQUIRED_ERROR",
                field
            }));
            return {
                valid: false,
                message,
                newValue: value,
                hasRegulations: false,
                validationSkipped: false
            };
        }
    } else {
        if (field.meta && field.meta.rejectedAnswers && domainEnableRejectedAnswer) {
            /* rejected Answers validation */ const rejectedAnswer = rejectedAnswersValidation(field, value, rejectedAnswersRules, rulesContext);
            if (rejectedAnswer) {
                return {
                    valid: rejectedAnswer.isValid,
                    message: rejectedAnswer.message || "",
                    newValue: value,
                    hasRegulations: false,
                    validationSkipped: false,
                    isRejectedAnswerResult: true
                };
            }
        }
        // if (field.pattern) {
        /* pattern validation */ const patternCheck = patternValidation(field, value);
        if (patternCheck) {
            const message1 = (0,capitalizeFirstLetter/* capitalizeFirstLetter */.f)(getErrorMessage({
                messages,
                fieldName,
                errorType: patternCheck.errorType || "INVALID_ERROR",
                field
            }));
            return {
                valid: patternCheck.isValid,
                message: message1 || "",
                newValue: value,
                hasRegulations: false,
                validationSkipped: false
            };
        }
        // }
        if (field.validationType && field.validationType !== "companyName" && field.validationType !== "streetAddress" && value) {
            /* server side validation */ const validationType = await serverSideValidation(field, value, selectedCountryCode, handleUpdateOffers, fieldName, domain, locale);
            if (validationType) {
                return {
                    valid: validationType.isValid,
                    message: validationType.message || "",
                    newValue: validationType.newValue,
                    hasRegulations: validationType.hasRegulations,
                    validationSkipped: validationType.validationSkipped
                };
            }
        }
    }
    return {
        valid: true,
        message: "",
        newValue: value,
        hasRegulations: false,
        validationSkipped: false
    };
};
const handleFieldMasking = (mask, value)=>{
    const handleUsPhoneNumberMasking = ()=>{
        const cleaned = value.replace(/[^0-9]/g, "");
        if (cleaned[0] === "1" && cleaned[1] === "1") {
            const x = cleaned.match(/([1]{0,1})(1{0,1})([0-9]{0,3})([0-9]{0,3})([0-9]{0,4})/) ?? "";
            return (x[1] ? "1" : "") + (x[3].length >= 1 ? x[1] ? " (" : "(" : "") + (x[3] ? x[3] : "") + (x[4].length >= 1 ? ") " : "") + (x[4] ? x[4] : "") + (x[5].length >= 1 ? "-" : "") + (x[5] ? x[5] : "");
        } else {
            const x1 = cleaned.match(/([1]{0,1})([0-9]{0,3})([0-9]{0,3})([0-9]{0,4})/) ?? "";
            return (x1[1] ? "1" : "") + (x1[2].length >= 1 ? x1[1] ? " (" : "(" : "") + (x1[2] ? x1[2] : "") + (x1[3].length >= 1 ? ") " : "") + (x1[3] ? x1[3] : "") + (x1[4].length >= 1 ? "-" : "") + (x1[4] ? x1[4] : "");
        }
    };
    const handleZipCodeMasking = ()=>{
        const zipCodeAllowedCharacters = value.replace(/[^0-9\-]/g, "");
        const lastIndexOf = zipCodeAllowedCharacters.lastIndexOf("-");
        if (lastIndexOf != 5 && lastIndexOf != -1) {
            return zipCodeAllowedCharacters.substring(0, lastIndexOf);
        }
        const matchedPattern = zipCodeAllowedCharacters.match(/(^[0-9]+$)|(^[0-9]{5}-[0-9]{4,}$)/);
        if (matchedPattern) {
            const dashIndexOf = matchedPattern[0].indexOf("-");
            const part2StartIndx = 5;
            const part1String = matchedPattern[0].substring(0, 5);
            const part2String = matchedPattern[0].substring(part2StartIndx, 10);
            return `${part1String}${part2String.length && dashIndexOf < 0 ? "-" : ""}${part2String}`;
        }
        return zipCodeAllowedCharacters.substring(0, 10);
    };
    const handlePostalCodeMasking = ()=>{
        const postalCodeAllowedCharacters = value.replace(/[^0-9a-zA-Z ]/g, "").toUpperCase();
        const lastIndexOf = postalCodeAllowedCharacters.lastIndexOf(" ");
        if (lastIndexOf != 3 && lastIndexOf != -1) {
            return postalCodeAllowedCharacters.substring(0, lastIndexOf);
        }
        const matchedPattern = postalCodeAllowedCharacters.match(/(^[0-9a-zA-Z]+$)|(^[0-9a-zA-Z]{3} [0-9a-zA-Z]{3,}$)/);
        if (matchedPattern) {
            const spaceIndexOf = matchedPattern[0].indexOf(" ");
            const part2StartIndx = 3;
            const part1String = matchedPattern[0].substring(0, 3);
            const part2String = matchedPattern[0].substring(part2StartIndx, 7);
            return `${part1String}${part2String.length && spaceIndexOf < 0 ? " " : ""}${part2String}`;
        }
        return postalCodeAllowedCharacters.substring(0, 7);
    };
    switch(mask){
        case "us-phone":
            return handleUsPhoneNumberMasking();
        case "zipCode":
            return handleZipCodeMasking();
        case "postalCode":
            return handlePostalCodeMasking();
        default:
            return "";
    }
};


/***/ }),

/***/ 99732:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./ar.json": 33502,
	"./en.json": 92591,
	"./es.json": 79875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 99732;

/***/ }),

/***/ 33502:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"REQUIRED_ERROR":"${field} مطلوب","INVALID_ERROR":"يرجى إدخال ${field} صالح","MAX_DATE_ERROR":"يرجى إدخال ${field} قبل ${date}","MIN_DATE_ERROR":"يرجى إدخال ${field} بعد ${date}"}');

/***/ }),

/***/ 92591:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"REQUIRED_ERROR":"${field} is required","INVALID_ERROR":"Please enter a valid ${field}","MAX_DATE_ERROR":"Please enter a ${field} before ${date}","MIN_DATE_ERROR":"Please enter a ${field} after ${date}"}');

/***/ }),

/***/ 79875:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"REQUIRED_ERROR":"${field} es requerido","INVALID_ERROR":"Por favor, introduzca un ${field} válido","MAX_DATE_ERROR":"Por favor, introduzca un ${field} antes ${date}","MIN_DATE_ERROR":"Por favor, introduzca un ${field} después ${date}"}');

/***/ })

}]);